module.exports = __webpack_public_path__ + "static/media/insurance.e1fa9ac7.svg";